const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FeaturedCollectionCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        dragStartThreshold: 10,
        drag: true,
        slides: {
          perView: 1.25,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.25,
              spacing: 14,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 3.25,
              spacing: 14,
            },
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 4.25,
              spacing: 14,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    return slider
  }
}

if (!customElements.get('featured-collection-carousel')) {
  customElements.define(
    'featured-collection-carousel',
    FeaturedCollectionCarousel,
  )
}
